import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-719f5da2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border color-detail",
  role: "status",
  style: {"height":"100px","width":"100px"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "sr-only" })
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "color-detail" }, "Loading in progress...", -1))
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
]

import { computed } from "vue";
import LoadingService from "@/services/LoadingService";


export default /*#__PURE__*/_defineComponent({
  __name: 'LoadingOverlay',
  setup(__props) {

const isLoading = computed(() => LoadingService.getIsLoading());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["overlay", {
      show: _unref(isLoading),
    }])
    }, null, 2),
    _createElementVNode("div", {
      class: _normalizeClass(["spanner", {
      show: _unref(isLoading),
    }])
    }, _hoisted_3, 2)
  ], 64))
}
}

})